<template>
    <div class="content-i">
        <div class="content-box">
            <div class="maintenance-page">
                <div class="maintenance-logo">
                    <img alt="" src="/images/logo.png">
                </div>
                <h2>We will be back soon!</h2>
                <div v-html="maintenanceMessage"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'maintenance',
    
    data() {
        return {
            maintenanceMessage: ''
        }
    },
    
    created() {
        this.peer.common.maintenanceSettings().then((r) => {
            if(r.maintenance === 2)
                this.maintenanceMessage = r.message.long
            else {
                this.$router.push({
                    name: 'home'
                })
            }
        })
    }
}
</script>

<style>

</style>
